import { createRoute, Outlet, redirect } from '@tanstack/react-router';
import { rootRoute } from './root-route';
import { getKeycloak } from '@/auth/keycloak-instance';

export const authenticatedRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: '_authenticated',
  beforeLoad: ({ location }) => {
    // Every authenticated user in the recruiters realm is a recruiter — realm
    // membership is the authorization boundary, so there's no role gate here.
    // Squad scoping (and the admin cross-squad bypass) is enforced server-side
    // by Core's consultorScopeGuard; the SPA only needs a valid session.
    const keycloak = getKeycloak();
    if (!keycloak.authenticated) {
      // EU-756 (OKR-003): carry the requested path so the login lands back on
      // it — a deep link like /okrs used to be dropped on the home page.
      // `location.href` is path + search + hash, never an absolute URL.
      throw redirect({ to: '/login', search: { redirect: location.href } });
    }
  },
  component: () => <Outlet />,
});
